import { getTabIndex } from '@/datalayer/App.datalayer.utils';
import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';
import { pushClickToDL, TabsDLClick } from '../ComplexTabsList.datalayer';

enum Selectors {
  // Target
  CTA = 'a',
  Tab = '.gtm-tab',
  MUILink = 'MuiLink-root',
  MUIButton = 'MuiButton-root',
  // Content
  TabHeadline = '.gtm-headline',
  CTAheadline = '[role="tabpanel"]:not([hidden]) .gtm-headline',
}

export const mapTarget = mapTargetBySelectors([Selectors.Tab, Selectors.CTA]);

export const onDatalayer = ({ componentRef, target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;
  const isTab = target?.classList.contains(Selectors.Tab.replace('.', ''));

  if (isTab) {
    const headlineId = target?.getAttribute('aria-controls')?.replace('-thumbnail', '') || '';
    const documentHeadline =
      componentRef?.current?.querySelector(`#${headlineId} ${Selectors.TabHeadline}`)
        ?.textContent || '';

    return {
      event: 'clickTab',
      eventCategory: 'Complex Tab',
      ...(!!documentHeadline && { documentHeadline }),
      ...(!!documentHeadline && { tabLabel: documentHeadline }),
      ...(variantName && { variant_name: variantName }),
    };
  }

  const documentHeadline =
    componentRef?.current?.querySelector(Selectors.CTAheadline)?.textContent || '';

  // CTA Click
  return {
    event: 'clickCTA',
    eventCategory: 'Complex Tab',
    ...(!!documentHeadline && { documentHeadline }),
    ...(variantName && { variant_name: variantName }),
  };
};

export const onDatalayerTabClick = ({
  componentRef,
  target,
}: OnDatalayerProps): TabsDLClick | undefined => {
  if (!target) {
    return undefined;
  }
  const elWithTabIndex = target.closest('[role=tab]') || target.closest('[role=tabpanel]');
  const { id } = elWithTabIndex;
  const titleElement = componentRef?.current?.querySelector(
    `#vertical-tabpanel-${getTabIndex(id)} ${Selectors.TabHeadline}`,
  );
  const title = titleElement?.children[0].textContent || '';

  return pushClickToDL({ title, target });
};
